"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setBackgroundColor = exports.getIsFocused = exports.getWasFocused = exports.updateFocus = exports.getElapsedTime = exports.getUpdateDeltaScaled = exports.getUpdateDelta = exports.setUpdateDeltaScaled = exports.setUpdateDelta = exports.getGameSize = exports.setPhaserScene = exports.getPhaserScene = exports.hasScene = exports.getUnsyncedRando = exports.createId = void 0;
var randoInstanced_sidecar_1 = require("@dive/to-engine/randoInstanced-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var _idCounter = 100;
function createId(existingId) {
    if (existingId === void 0) { existingId = 0; }
    // TODO: check for duplicate ids
    if (existingId) {
        if (existingId > _idCounter) {
            _idCounter = existingId;
        }
        return existingId;
    }
    _idCounter++;
    return _idCounter;
}
exports.createId = createId;
var _unsyncedRando = randoInstanced_sidecar_1.randoInstanced.createRando(Date.now());
function getUnsyncedRando() {
    return _unsyncedRando;
}
exports.getUnsyncedRando = getUnsyncedRando;
var _scene = null;
function hasScene() {
    return _scene != null;
}
exports.hasScene = hasScene;
function getPhaserScene() {
    if (!_scene) {
        throw new Error('no scene');
    }
    return _scene;
}
exports.getPhaserScene = getPhaserScene;
function setPhaserScene(scene) {
    _scene = scene;
}
exports.setPhaserScene = setPhaserScene;
function getGameSize() {
    var height = getPhaserScene().game.config.height;
    var width = getPhaserScene().game.config.width;
    return { width: width, height: height };
}
exports.getGameSize = getGameSize;
var _updateDeltaTime = 0;
var _updateDeltaTimeScaled = 0;
var _elapsedTime = 0;
function setUpdateDelta(updateTime) {
    _updateDeltaTime = updateTime;
    _elapsedTime += updateTime;
}
exports.setUpdateDelta = setUpdateDelta;
function setUpdateDeltaScaled(updateTimeScaled) {
    _updateDeltaTimeScaled = updateTimeScaled;
}
exports.setUpdateDeltaScaled = setUpdateDeltaScaled;
function getUpdateDelta() {
    return _updateDeltaTime;
}
exports.getUpdateDelta = getUpdateDelta;
function getUpdateDeltaScaled() {
    return _updateDeltaTimeScaled;
}
exports.getUpdateDeltaScaled = getUpdateDeltaScaled;
function getElapsedTime() {
    return _elapsedTime;
}
exports.getElapsedTime = getElapsedTime;
var _lastLastFocus = undefined;
var _lastFocus = undefined;
function updateFocus() {
    // focus detection
    // let curFocus = common.getPhaserScene().game.hasFocus
    var curFocus = document.hasFocus();
    // console.log('focus is', curFocus)
    _lastLastFocus = _lastFocus;
    _lastFocus = curFocus;
    if (curFocus !== _lastFocus) {
        if (curFocus) {
            console.log('focus', 'gained');
        }
        else {
            console.log('focus', 'lost');
        }
        return true;
    }
    return false;
    //return curFocus
}
exports.updateFocus = updateFocus;
function getWasFocused() {
    return _lastLastFocus;
}
exports.getWasFocused = getWasFocused;
function getIsFocused() {
    return _lastFocus;
}
exports.getIsFocused = getIsFocused;
var _phaserRoot = null;
function setBackgroundColor(color) {
    if (!_phaserRoot) {
        _phaserRoot = document.getElementById('phaser-root');
    }
    assert_sidecar_1.assert.notNil(_phaserRoot, 'no phaser root');
    _phaserRoot.style.backgroundColor = '#' + color.toString(16);
}
exports.setBackgroundColor = setBackgroundColor;
